import { types } from "mobx-state-tree"
import TrafficTicket from "~/stores/models/TrafficTicket"

// Custom type to handle both string and Date objects
const DateType = types.union(
  types.string,
  types.model({
    __type: types.literal("Date"),
    iso: types.string,
  })
)

const FinancingPlan = types.model("FinancingPlan", {
  objectId: types.identifier, // Unique identifier for the financing plan
  plan: types.optional(types.string, ""), // Unique plan number
  status: types.string, // Status of the plan (active, paid, canceled, etc.)
  createdAt: types.string, // Indicates when the plan was created
  updatedAt: types.string, // Indicates when the plan was last updated
  customerFirstName: types.string, // First name of the customer
  customerLastName: types.string, // Last name of the customer
  customerEmail: types.string, // Email address of the customer
  customerPhone: types.string, // Phone number of the customer
  total: types.number, // Total amount of the financing plan
  amountPaid: types.number, // Total amount paid so far
  percentPaid: types.string, // Percentage of the total amount that has been paid
  balance: types.number, // Balance remaining after factoring in payments and the down payment
  frequency: types.number, // Payment frequency value
  frequencyUnits: types.string, // Payment frequency (days, weeks, months)
  term: types.number, // Financing plan term value
  termUnits: types.string, // Duration of the financing plan (e.g., in months)
  description: types.optional(types.string, ""), // Description of the plan
  paymentAmount: types.number, // Amount to be paid per installment
  downPayment: types.number, // Initial payment amount made by the customer
  dateOpened: types.optional(DateType, ""), // Date the plan was opened
  datePaid: types.maybeNull(types.string), // Date of the last payment made
  lastProcessedDate: types.maybeNull(types.string), // Tracks the last date the plan was processed by the job
  tickets: types.array(types.late(() => TrafficTicket)),
  userSession: types.optional(types.string, ""), // Session Token optionally provided by the backend
})

export default FinancingPlan
